export const AUTH_ROUTES = {
    LOGIN: '/',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
};

export const AUTH_PUBLIC_PATHS = [
    AUTH_ROUTES.LOGIN,
    AUTH_ROUTES.FORGOT_PASSWORD,
    AUTH_ROUTES.RESET_PASSWORD,
];